/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const LessThanOrEqualRevision: core.serialization.ObjectSchema<
    serializers.LessThanOrEqualRevision.Raw,
    Truvity.LessThanOrEqualRevision
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace LessThanOrEqualRevision {
    export interface Raw {
        value: number;
    }
}
